import React from "react";
import "../assets/css/solution.css";
import icon1 from "../assets/images/solution_icon/icon1.png";
import icon2 from "../assets/images/solution_icon/icon2.png";
import icon3 from "../assets/images/solution_icon/icon3.png";
import icon4 from "../assets/images/solution_icon/icon4.png";
import icon5 from "../assets/images/solution_icon/icon5.png";
import icon6 from "../assets/images/solution_icon/icon6.png";
import icon7 from "../assets/images/solution_icon/icon7.png";
import circular_ellipse from "../assets/images/solution_icon/Ellipse.png"

const EllipseComponent = () => {
  const icons = [
    { id: 1, src: icon1, label: "Platforms" },
    { id: 2, src: icon2, label: "Managed Detection" },
    { id: 3, src: icon3, label: "Security Operations" },
    { id: 4, src: icon4, label: "Threat Detection" },
    { id: 5, src: icon5, label: "Vulnerability Management" },
    { id: 6, src: icon6, label: "Managed Services" },
    { id: 7, src: icon7, label: "Compliance" },
  ];

  return (
    // <div className="d-flex justify-content-center w-100">
      <div className="container text-center">
        {/* Top Button */}
        <div className="mb-4">
          <button className="btn btn-primary solution-btn">Solutions</button>
        </div>

        {/* Ellipse Section */}
        <div className="ellipse-container position-relative">
          {/* Circular Ellipse Image */}
          <img
            src={circular_ellipse}
            alt="Circular Ellipse"
            className="ellipse-background"
          />

          {/* Ellipse Items */}
          {icons.map((item, index) => (
            item.label === 'Platforms' ? (
              <div
                className="ellipse-item"
                key={item.id}
                style={{
                  "--angle": `${(index * 360) / icons.length}deg`, // Evenly space out items
                }}
              >
                <img src={item.src} alt={item.label} className="ellipse-icon platform-item" style={{ "transform": `rotate(${(360 - ((index * 360) / icons.length))}deg)` }} />

              </div>
            ) :
              (
                <div
                  className="ellipse-item"
                  key={item.id}
                  style={{
                    "--angle": `${(index * 360) / icons.length}deg`, // Evenly space out items
                  }}
                >
                  <img src={item.src} alt={item.label} className="ellipse-icon" style={{ "transform": `rotate(${(360 - ((index * 360) / icons.length))}deg)` }} />

                </div>
              )
          ))}
        </div>

        {/* Bottom Buttons */}
        <div className="d-flex justify-content-center gap-3">
          <button className="btn btn-outline-primary download-btn">
            Download E-book
          </button>
          <button className="btn btn-warning view-all-btn">
            View All Services
          </button>
        </div>
      </div>
    // </div>
  );
};

export default EllipseComponent;
